<template>
  <div class="datenschutz-page">
    <h1 class="bold-font datenschutz-title">Datenschutzerklärung</h1>
    <div class="section">
      <h2 class="bold-font datenschutz-subheading">
        Abschnitt 1 - Allgemeine Informationen
      </h2>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          1.1. Verantwortlicher
        </h4>
        <span class="row datenschutz-subsection"
          >Verantwortlicher im Sinne des Art. 4 Nr. 7 DSGVO ist derjenige, der
          allein oder gemeinsam mit anderen über die Zwecke und Mittel der
          Verarbeitung von personenbezogenen Daten entscheidet.
          <br />
          <br />
        </span>
        <div class="datenschutz-subsection">
          Im Hinblick auf unser Portal ist Betreiber die:
          <br />
          <br />
        </div>
        <div class="datenschutz-subsection">
          Ignite GmbH Ernst-Heckel-Straße 6A
        </div>
        <div class="datenschutz-subsection">66386 St. Ingbert</div>
        <div class="datenschutz-subsection">Deutschland</div>
        <div class="datenschutz-subsection">
          E-Mail: &nbsp;<a href="mailto:info@ignite-group.de" target="_blank"
            >info@ignite-group.de</a
          >
        </div>
        <div class="datenschutz-subsection">Tel.: +49 6894 99956 – 0</div>
        <div class="datenschutz-subsection">Fax: +49 32 221739475</div>
        <div class="datenschutz-subsection">
          Es wurde ein Datenschutzbeauftragter benannt: Dr. Sebastian Kraska
          Marienplatz 2 80331 München
        </div>
        <div class="datenschutz-subsection">
          Deutschland E-Mail: &nbsp;
          <a href="mailto:email@iitr.de" target="_blank">email@iitr.de</a>&nbsp;
          Website:&nbsp;
          <a href="http://www.iitr.de/" target="_blank">http://www.iitr.de/</a
          >&nbsp;
        </div>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          1.2. Bereitstellung der Website und Erstellung von Logfiles
        </h4>
        <span class="row datenschutz-subsection">
          Bei jedem Aufruf unserer Internetseite erfasst unser System
          automatisiert Daten und Informationen des jeweils abrufenden Gerätes
          (z.B. Computer, Mobiltelefon, Tablet, etc.).
        </span>
        <br />
        <div class="bold-font datenschutz-subsection">
          Welche personenbezogenen Daten werden erhoben und in welchem Umfang
          werden diese verarbeitet?
        </div>
        <br />
        <div class="datenschutz-subsection">
          (1) Informationen über den Browsertyp und die verwendete Version;
        </div>
        <div class="datenschutz-subsection">
          (2) Das Betriebssystem des Abrufgerätes;
        </div>
        <div class="datenschutz-subsection">
          (3) Hostname des zugreifenden Rechners;
        </div>
        <div class="datenschutz-subsection">
          (4) Die IP-Adresse des Abrufgerätes;
        </div>
        <div class="datenschutz-subsection">
          (5) Datum und Uhrzeit des Zugriffs;
        </div>
        <div class="datenschutz-subsection">
          (6) Websites und Ressourcen (Bilder, Dateien, weitere Seiteninhalte),
          die auf unserer Internetseite aufgerufen wurden;
        </div>
        <div class="datenschutz-subsection">
          (7) Websites, von denen das System des Nutzers auf unsere
          Internetseite gelangte (Referrer-Tracking);
        </div>
        <div class="datenschutz-subsection">
          (8) Meldung, ob der Abruf erfolgreich war;
        </div>
        <div class="datenschutz-subsection">(9) Übertragene Datenmenge</div>
        <br />
        <span class="row datenschutz-subsection">
          Diese Daten werden in den Logfiles unseres Systems gespeichert. Eine
          Speicherung dieser technischen Daten zusammen mit personenbezogenen
          Daten eines konkreten Nutzers findet nicht statt, so dass eine
          Identifizierung einzelner Seitenbesucher nicht erfolgt.
        </span>
        <br />
        <span class="row datenschutz-subsection">
          Diese Daten werden aus technischen Gründen in den Logfiles unseres
          Systems gespeichert, da bei der Übertragung von Daten von Servern zu
          Browsern diese Daten bei der Nutzung des IP-Protokolls technisch
          notwendig sind und automatisch aus technischen Gründen anfallen. Durch
          die bei der Datenübertragung verursachten IP-Protokolldaten ist es uns
          möglich die Daten mit Login-Versuchen eines konkreten Nutzers im
          Einzelfall zusammenzuführen. Eine solche Zusammenführung und
          Auswertung der Daten von uns findet jedoch nicht statt, in der Form,
          dass eine Identifizierung konkreter Seitenbesucher erfolgt.
        </span>
        <br />
        <span class="row datenschutz-subsection">
          Bei der Nutzung der Registrierungs- oder Log-In-Funktion können diese
          Informationen nach erfolgreicher Anmeldung dem Benutzerkonto
          zugeordnet werden. Es erfolgt durch uns keine Auswertung der
          Protokolldaten für werbliche oder betriebliche Zwecke sondern nur im
          Einzelfall aus Sicherheitsgesichtspunkten, wie im nachfolgenden Zweck
          erläutert.
        </span>
        <br />
        <div class="bold-font datenschutz-subsection">
          Rechtsgrundlage für die Verarbeitung personenbezogener Daten
        </div>
        <br />
        <span class="row datenschutz-subsection">
          Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse). Unser
          berechtigtes Interesse besteht darin, die Erreichung des nachfolgend
          geschilderten Zwecks zu gewährleisten.
        </span>
        <br />
        <div class="bold-font datenschutz-subsection">
          Zweck der Datenverarbeitung
        </div>
        <br />
        <span class="row datenschutz-subsection">
          Die vorübergehende (automatisierte) Speicherung der Daten ist für den
          Ablauf eines Websitebesuchs erforderlich, um eine Auslieferung des
          Online-Buchungsportals in Form einer Website zu ermöglichen. Die
          Speicherung und Verarbeitung der personenbezogenen Daten erfolgt zudem
          zur Erhaltung der Kompatibilität unserer Internetseite für möglichst
          alle Besucher und zur Missbrauchsbekämpfung und Störungsbeseitigung.
          Hierfür ist es notwendig, die technischen Daten des abrufenden
          Rechners zu loggen, um so frühestmöglich auf Darstellungsfehler,
          Angriffe auf unsere IT-Systeme und/oder Fehler der Funktionalität
          unserer Internetseite reagieren zu können. Zudem dienen uns die Daten
          zur Optimierung der Website und zur generellen Sicherstellung der
          Sicherheit unserer informationstechnischen Systeme.
          <br /><br />
          Wir behalten uns jedoch vor im Falle der Bekämpfung von
          missbräuchlichen Anmeldeversuchen bei einzelnen Nutzerkonten
          Logfile-Daten aus Sicherheitsgesichtspunkten auszuwerten, um wirksame
          Gegenmaßnahmen für missbräuchliche Seitenzugriffe und Angriffe auf
          unsere technischen Systeme zu unterbinden.
        </span>
        <br />
        <div class="bold-font datenschutz-subsection">
          Dauer der Speicherung
        </div>
        <br />
        <span class="row datenschutz-subsection">
          Die Löschung der vorgenannten technischen Daten erfolgt, sobald sie
          nicht mehr benötigt werden, um die Kompatibilität der Internetseite
          für alle Besucher zu gewährleisten.
        </span>
        <br />
        <div class="bold-font datenschutz-subsection">
          Widerspruchs- und Löschungsmöglichkeit
        </div>
        <br />
        <span class="row datenschutz-subsection">
          Sie können der Verarbeitung jederzeit gem. Art. 21 DSGVO widersprechen
          und eine Löschung von Daten gem. Art. 17 DSGVO verlangen. Welche
          Rechte Ihnen zustehen und wie Sie diese geltend machen, finden Sie im
          unteren Bereich dieser Datenschutzerklärung.
        </span>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          1.3. Allgemeine Hinweise zur Kontaktaufnahme
        </h4>
        <span class="row datenschutz-subsection">
          Bitte beachten Sie, dass bei einer unverschlüsselten Kommunikation per
          E-Mail oder Fax die vollständige Datensicherheit auf dem
          Übertragungsweg zu unseren IT-Systemen nicht gewährleistet werden
          kann, sodass wir bei Informationen mit hohem Geheimhaltungsbedürfnis
          ausdrücklich eine verschlüsselte Kommunikation oder den Postweg
          empfehlen. Bei der Übermittlung per E-Mail oder Fax bestehen unter
          anderem die folgenden Risiken:
        </span>
        <ul class="unordered-list">
          <li>
            personenbezogenen Daten könnten wegen einer nicht korrekten Eingabe
            der E-Mail-Adresse bzw. Faxnummer Dritten unbefugt offenbart werden;
          </li>
          <li>
            Sie haben keine Informationen zur Empfängerseite, z.B. welche oder
            wie viele Mitarbeiter Zugang zur E-Mail bzw. zum Fax haben.;
          </li>
          <li>
            durch die Übertragung der Daten bei E-Mail oder Fax über mehrere
            verteilte Zwischenstellen besteht ohne Verschlüsselung grundsätzlich
            eine Zugriffsmöglichkeit für unbefugte Dritte.
          </li>
        </ul>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          1.4. Auftragsverarbeiter
        </h4>
        <span class="row datenschutz-subsection">
          Im Hinblick auf unsere Website kommen einige Auftragsverarbeiter zum
          Einsatz. Soweit der Einsatz bei einer besonderen Funktion (z.B.
          Kontaktformular) oder einem Webdienst erfolgt, wird dieser
          ausdrücklich an der dortigen Stelle benannt. Vorliegend kommen die
          folgenden weiteren Auftragsverarbeiter zum Einsatz:
        </span>
        <br />
        <div class="datenschutz-subsection">
          Isastis, Kralja Tvrtka 12, 71000 Sarajevo, Bosna i Hercegovina
        </div>
        <div class="datenschutz-subsection">verarbeitet.</div>
        <br />
        <span class="row datenschutz-subsection">
          Die Verarbeitung Ihrer Daten erfolgt auf der Basis eines Vertrags zur
          Auftragsverarbeitung gemäß Art. 28 DSGVO, der die Rechtsgrundlage der
          Weitergabe der Daten an diese Firma darstellt. Zudem wurden weitere
          Maßnahmen zum Schutz der personenbezogenen Daten vorgenommen.
        </span>
      </div>
    </div>
    <div class="section">
      <h2 class="bold-font datenschutz-subheading">
        2. Abschnitt 2 – Allgemeine Informationen
      </h2>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          2.1. Besondere Funktionen der Internetseite
        </h4>
        <span class="row datenschutz-subsection">
          Unser Online-Portal bietet Ihnen verschiedene Funktionen. Bei der
          Nutzung des Benutzerkontos werden auch personenbezogene Daten erhoben,
          verarbeitet und gespeichert. Nachfolgend erklären wir, was mit diesen
          Daten geschieht:
        </span>
        <br />
        <div class="bold-font datenschutz-subsection">
          Registrierung & Login
        </div>
        <ul class="unordered-list">
          <li>
            Welche personenbezogenen Daten werden erhoben und in welchem Umfang
            werden diese verarbeitet? Bei der Registrierung eines neuen
            Benutzerkontos erheben wir die nachfolgenden Daten: E-Mail Adresse,
            Firma / Behörde, Vorname, Nachname, Passwort. Wir verwenden die
            eingegebene E-Mail-Adresse bei der Registrierung zur Verifikation
            der Echtheit der bei der Registrierung verwendeten E-Mail-Adresse.
            Beim Login in das Benutzerkonto benötigen wir die von Ihnen
            hinterlegten Zugangsdaten wie E-Mail-Adresse und Passwort. Vor- und
            Nachname dienen der persönlichen Ansprache und Zuordnung im System.
          </li>
          <li>
            Rechtsgrundlage für die Verarbeitung personenbezogener Daten
            <br />
            Art. 6 Abs. 1 lit. b DSGVO (Durchführung (vor)vertraglicher
            Maßnahmen) in Verbindung mit unseren Allgemeinen
            Geschäftsbedingungen (AGB). Die Erstellung eines Benutzerkontos
            durch Registrierung ist Voraussetzung für die Nutzung der Plattform
          </li>
          <li>
            Zweck der Datenverarbeitung
            <br />
            Sie haben auf unserer Internetseite die Möglichkeit einen separaten
            Login-Bereich zu nutzen. Damit wir ihre Berechtigung zur Nutzung des
            geschützten Bereichs prüfen können, müssen Sie ihre Login-Daten
            (E-Mail-Adresse bzw. Nutzername und Passwort) in das entsprechende
            Formular eingeben. Wir verwenden diese Daten, um ein persönliches
            Benutzerkonto zu erstellen zu können und eine spätere
            Anmeldemöglichkeit bereitzustellen. Durch die Bereitstellung des
            Benutzerkontos können die eingegebenen Daten und Einstellungen zu
            Benachrichtigungen und Informationen verwalten. Ebenfalls verwenden
            wir die Daten, um im Bedarfsfall bei vergessenem Passwort den
            Account wieder zurückzusetzen. Auch die Nutzung der Plattform wird
            durch den Account ermöglicht und geschützt.
            <br />
            <br />
            Die E-Mail Adresse werden wir zudem verwenden um Sie über
            Neuigkeiten aus dem Portal (insbesondere im Hinblick auf die von
            Ihnen eingespeicherten Suchparameter) zu informieren.
            <br />
          </li>
          <li>
            Dauer der Speicherung
            <br />
            Die erhobenen Daten werden so lange gespeichert, wie Sie ein
            Benutzerkonto bei uns unterhalten.
          </li>
          <li>
            Widerrufs- und Löschungsmöglichkeit
            <br />
            Welche Rechte ihnen zustehen, und wie Sie diese geltend machen,
            finden Sie im unteren Bereich dieser Datenschutzerklärung.
          </li>
          <li>
            Erforderlichkeit der Angabe personenbezogener Daten
            <br />
            Die Nutzung des Login-Bereichs und die Zurverfügungstellung der für
            eine Registrierung benötigten Daten in unserem Portal ist zur
            Nutzung des geschützten Bereiches vertraglich vorgeschrieben. Die
            Nutzung des durch den Login-Bereich geschützten Inhalts ist ohne die
            Eingabe der personenbezogenen Daten nicht möglich. Sofern Sie
            unseren Login-Bereich nach der erfolgten Registrierung nutzen
            möchten, müssen Sie die als Pflichtangaben gekennzeichneten Felder
            (Benutzername und Passwort) ausfüllen. Die Eingabe der Daten setzt
            das Bestehen eines Benutzerkontos voraus. Eine Anmeldung ist nicht
            möglich, wenn die von Ihnen eingegebenen Daten fehlerhaft sind.
            Sofern die Daten von Ihnen falsch oder nicht eingegeben werden, kann
            der geschützte Bereich nicht genutzt werden. Der Rest des
            Online-Buchungsportals ist jedoch weiterhin ohne Login nutzbar.
          </li>
        </ul>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          2.2. Webdienste und Webtracker
        </h4>
        <span class="row datenschutz-subsection">
          Wir erheben, verarbeiten und speichern bei dem Aufruf dieser
          Internetseite oder einzelner Dateien der Internetseite folgende Daten:
          IP-Adresse, Webseite, von der aus die Datei abgerufen wurde, Name der
          Datei, Datum und Uhrzeit des Abrufs, übertragene Datenmenge und
          Meldung über den Erfolg des Abrufs (sog. Web-Log). Diese Zugriffsdaten
          verwenden wir ausschließlich in nicht personalisierter Form für die
          stetige Verbesserung unseres Internetangebots und zu statistischen
          Zwecken. Wir setzen zur Auswertung der Besuche dieser Internetseite
          zudem noch folgende Webtracker ein:
        </span>
        <ul class="unordered-list">
          <li>
            <div class="bold-font">Hotjar</div>
            <div class="row-with-link">
              <span>
                Wir verwenden auf unserer Seite den Dienst Hotjar des
                Unternehmens Hotjar Ltd., Dragonara Business Centre, 5th Floor,
                Dragonara Road, 3141 Paceville St Julian's STJ, Malta, Website:
              </span>
              <a href="https://www.hotjar.com/" target="_blank"
                >https://www.hotjar.com/</a
              >
              <span>
                . Die Übermittlung personenbezogener Daten erfolgt
                ausschließlich an Server in der europäischen Union.
              </span>
            </div>
            <br />
            <span class="row">
              Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten
              stellt Ihre Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO bzw. Art.
              9 Abs. 2 lit. a DSGVO dar, die Sie auf unserer Internetseite
              getätigt haben.
            </span>
            <br />
            <span class="row">
              Über Hotjar führen wir eine Verhaltensanalyse über die Nutzung
              unserer Websites durch und werten Feedback über Tools wie
              Heatmaps, Sitzungsaufzeichnungen und Umfragen aus. Ihre
              Einwilligung können Sie jederzeit widerrufen. Nähere Informationen
              zum Widerruf Ihrer Einwilligung finden Sie entweder bei der
              Einwilligung selbst oder am Ende dieser Datenschutzerklärung.
            </span>
            <br />
            <div class="row-with-link">
              <span>
                Weitere Informationen zum Handling der übertragenen Daten finden
                Sie in der Datenschutzerklärung des Anbieters unter
              </span>
              <a
                href="https://www.hotjar.com/legal/policies/privacy/"
                target="_blank"
                >https://www.hotjar.com/legal/policies/privacy/</a
              >
              <span>. Der Anbieter bietet unter </span>
              <a
                href="https://help.hotjar.com/hc/en-us/articles/360002735873-How-to-Stop-Hotjar-From-Collecting-your-Data"
                target="_blank"
                >https://help.hotjar.com/hc/en-us/articles/360002735873-How-to-Stop-Hotjar-From-Collecting-your-Data</a
              >
              <span> zusätzlich eine Opt-Out Möglichkeit an. </span>
            </div>
          </li>
          <li>
            <div class="bold-font">Google Cloud APIs</div>
            <div class="row-with-link">
              <span>
                Wir verwenden auf unserer Seite den Dienst Google Cloud APIs des
                Unternehmens Google Ireland Limited, Gordon House, Barrow
                Street, 4 Dublin, Irland, E-Mail:
              </span>
              <a href="mailto:support-deutschland@google.com" target="_blank"
                >support-deutschland@google.com</a
              >
              <span>, Website: </span>
              <a href="https://www.google.com/" target="_blank"
                >https://www.google.com/</a
              >
              <span>
                . Die Übermittlung personenbezogener Daten erfolgt auch in die
                USA. Im Hinblick auf die Übermittlung personenbezogener Daten in
                die USA besteht ein Angemessenheitsbeschlusses zum EU-US Data
                Privacy Framework der EU Kommission im Sinne des Art. 45 DSGVO
                (nachfolgend: DPF -
              </span>
              <a
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                >https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en</a
              >
              <span>
                ). Der Betreiber des Dienstes ist im Rahmen des DPF
                zertifiziert, so dass für die Übermittlung das übliche
                Schutzniveau der DSGVO gilt.
              </span>
            </div>
            <br />
            <span class="row">
              Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten
              stellt Ihre Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO bzw. Art.
              9 Abs. 2 lit. a DSGVO dar, die Sie auf unserer Internetseite
              getätigt haben.
            </span>
            <br />
            <span class="row">
              Wir verwenden Google APIs um auf der Internetseite weitere Dienste
              von Google nachladen zu können. Bei Google Apis handelt es sich um
              eine Sammlung von Schnittstellen zur Kommunikation zwischen den
              verschiedenen Google Diensten, die auf Ihrer Website zum Einsatz
              kommen. Der Dienst wird insbesondere zur Darstellung der Google
              Fonts-Schriftarten und zur Bereitstellung der Google Maps-Karte.
            </span>
            <br />
            <span class="row">
              Zur Verarbeitung selbst erhebt der Dienst bzw. wir folgende Daten:
              IP-Adresse
            </span>
            <br />
            <div class="row-with-link">
              <span>
                Sofern der Dienst auf unserer Website aktiv geschaltet ist,
                stellt unsere Website eine Verbindung zu den Servern des
                Unternehmens Google Ireland Limited her und überträgt die
                benötigten Daten. Im Rahmen der Auftragsverarbeitung kann es
                auch zu einer Übermittlung von personenbezogenen Daten an die
                Server des Unternehmens Google LLC, 1600 Amphitheatre Parkway,
                94043 Mountain View, Vereinigte Staaten kommen. Beim Einsatz des
                Google-Dienstes auf unserer Website werden von Google
                gegebenenfalls Informationen von weiteren Google-Diensten
                übermittelt und verarbeitet, um Hintergrunddienste für die
                Anzeige und Datenverarbeitung der von Google bereitgestellten
                Dienste zu erbringen. Hierzu erfolgt gegebenenfalls auch eine
                Datenübertragung an die Google-Dienste Google Cloud, Google
                Maps, Google Ads und Google Fonts gemäß der
                Google-Datenschutzerklärung in datenschutzrechtlicher
                Verantwortung von Google. Die Zertifizierung des Anbieters im
                Rahmen des EU-US Data Privacy Frameworks können Sie unter
              </span>
              <a
                href="https://www.dataprivacyframework.gov/list"
                target="_blank"
                >https://www.dataprivacyframework.gov/list</a
              >
              <span> abrufen.</span>
            </div>
            <br />
            <span class="row">
              Ihre Einwilligung können Sie jederzeit widerrufen. Nähere
              Informationen zum Widerruf Ihrer Einwilligung finden Sie entweder
              bei der Einwilligung selbst oder am Ende dieser
              Datenschutzerklärung.
            </span>
            <div class="row-with-link">
              <span
                >Weitere Informationen zum Handling der übertragenen Daten
                finden Sie in der Datenschutzerklärung des Anbieters unter
              </span>
              <a href="https://policies.google.com/privacy" target="_blank"
                >https://policies.google.com/privacy.</a
              >
            </div>
            <br />
            <div class="row-with-link">
              <span> Der Anbieter bietet unter </span>
              <a
                href="https://support.google.com/My-Ad-Center-Help/answer/12155451?hl=de"
                target="_blank"
                >https://support.google.com/My-Ad-Center-Help/answer/12155451?hl=de</a
              >
              <span> zusätzlich eine Opt-Out Möglichkeit an.</span>
            </div>
          </li>
          <li>
            <div class="bold-font">Google Fonts</div>
            <div class="row-with-link">
              <span>
                Wir verwenden auf unserer Seite den Dienst Google Fonts des
                Unternehmens Google Ireland Limited, Gordon House, Barrow
                Street, 4 Dublin, Irland, E-Mail:
              </span>
              <a href="mailto:support-deutschland@google.com" target="_blank"
                >support-deutschland@google.com</a
              >
              <span>, Website: </span>
              <a href="https://www.google.com/" target="_blank"
                >https://www.google.com/.</a
              >
              <span>
                Die Übermittlung personenbezogener Daten erfolgt auch in die
                USA. Im Hinblick auf die Übermittlung personenbezogener Daten in
                die USA besteht ein Angemessenheitsbeschlusses zum EU-US Data
                Privacy Framework der EU Kommission im Sinne des Art. 45 DSGVO
                (nachfolgend: DPF -
              </span>
              <a
                href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
                target="_blank"
                >https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en</a
              >
              <span>
                ). Der Betreiber des Dienstes ist im Rahmen des DPF
                zertifiziert, so dass für die Übermittlung das übliche
                Schutzniveau der DSGVO gilt.
              </span>
            </div>
            <br />
            <span class="row">
              Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten
              stellt Ihre Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO bzw. Art.
              9 Abs. 2 lit. a DSGVO dar, die Sie auf unserer Internetseite
              getätigt haben.
            </span>
            <br />
            <span class="row">
              Wir verwenden den Dienst Google Fonts um auf unserer Seite
              attraktive Schriftarten einbinden zu können, um Ihnen unsere
              Webseite in einer optisch besseren Version anzeigen zu können.
              Ebenfalls kommt der Dienst auf unserer Webseite gegebenenfalls zum
              Einsatz wenn andere Google-Dienste auf unserer Webseite
              nachgeladen werden, die Google Fonts-Schriftarten zur Ausführung
              benötigen. Dies ist beispielsweise dann der Fall, sofern unsere
              Webseite Google-Dienste nutzt, die zur Ausführung Google Fonts
              zwingend benötigen.
            </span>
            <br />
            <span class="row">
              Zur Verarbeitung selbst erhebt der Dienst bzw. wir folgende Daten:
              Daten zu Schriftarten, IP-Adresse des Seitenbesuchers, Statistiken
              über den Gebrauch von Schriftarten und weitere Daten von
              Google-Diensten bezogen auf unsere Webseite.
            </span>
            <br />
            <div class="row-with-link">
              <span>
                Sofern der Dienst auf unserer Website aktiv geschaltet ist,
                stellt unsere Website eine Verbindung zu den Servern des
                Unternehmens Google Ireland Limited her und überträgt die
                benötigten Daten. Im Rahmen der Auftragsverarbeitung kann es
                auch zu einer Übermittlung von personenbezogenen Daten an die
                Server des Unternehmens Google LLC, 1600 Amphitheatre Parkway,
                94043 Mountain View, Vereinigte Staaten kommen. Beim Einsatz des
                Google-Dienstes auf unserer Website werden von Google
                gegebenenfalls Informationen von weiteren Google-Diensten
                übermittelt und verarbeitet, um Hintergrunddienste für die
                Anzeige und Datenverarbeitung der von Google bereitgestellten
                Dienste zu erbringen. Hierzu erfolgt gegebenenfalls auch eine
                Datenübertragung an die Google-Dienste Google Apis, Google Cloud
                und Google Ads gemäß der Google-Datenschutzerklärung. Die
                Zertifizierung des Anbieters im Rahmen des EU-US Data Privacy
                Frameworks können Sie unter
              </span>
              <a
                href="https://www.dataprivacyframework.gov/list"
                target="_blank"
                >https://www.dataprivacyframework.gov/list</a
              >
              <span> abrufen.</span>
            </div>
            <br />
            <span class="row">
              Ihre Einwilligung können Sie jederzeit widerrufen. Nähere
              Informationen zum Widerruf Ihrer Einwilligung finden Sie entweder
              bei der Einwilligung selbst oder am Ende dieser
              Datenschutzerklärung.
            </span>
            <br />
            <div class="row-with-link">
              <span
                >Weitere Informationen zum Handling der übertragenen Daten
                finden Sie in der Datenschutzerklärung des Anbieters unter
              </span>
              <a href="https://policies.google.com/privacy" target="_blank"
                >https://policies.google.com/privacy.</a
              >
            </div>
            <br />
            <div class="row-with-link">
              <span>Der Anbieter bietet unter </span>
              <a
                href="https://support.google.com/My-Ad-Center-Help/answer/12155451?hl=de"
                target="_blank"
                >https://support.google.com/My-Ad-Center-Help/answer/12155451?hl=de</a
              >
              <span> zusätzlich eine Opt-Out Möglichkeit an.</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          2.3. Unterrichtung über die Nutzung von Cookies
        </h4>
        <ul class="unordered-list">
          <li>
            <div class="bold-font datenschutz-subsection">
              Welche personenbezogenen Daten werden erhoben und in welchem
              Umfang werden diese verarbeitet?
            </div>
            <span>
              Auf verschiedenen Seiten integrieren und verwenden wir Cookies, um
              bestimmte Funktionen unserer Website zu ermöglichen und externe
              Webservices zu integrieren. Bei den sogenannten "Cookies" handelt
              es sich um kleine Textdateien, die Ihr Browser auf Ihrem
              Zugangsgerät speichern kann. Diese Textdateien enthalten eine
              charakteristische Zeichenkette, die den Browser eindeutig
              identifiziert, wenn Sie zu unserer Website zurückkehren. Der
              Prozess des Speicherns einer Cookie-Datei wird auch als "Setzen
              eines Cookies" bezeichnet. Cookies können hierbei sowohl von der
              Website selbst als auch von externen Webservices gesetzt werden.
              Die Cookies werden von unserer Website bzw. den externen
              Webservices gesetzt, um die volle Funktionalität unserer Website
              zu erhalten, die Benutzerfreundlichkeit zu verbessern oder um den
              mit Ihrer Einwilligung angegebenen Zweck zu verfolgen. Die
              Cookie-Technologie ermöglicht es uns auch, einzelne Besucher
              anhand von Pseudonymen, z.B. einer individuellen oder zufälligen
              IDs, zu erkennen, sodass wir mehr individuelle Dienstleistungen
              anbieten können. Details sind in der folgenden Tabelle aufgeführt.
            </span>
          </li>
          <li>
            <div class="bold-font datenschutz-subsection">
              Rechtsgrundlage für die Verarbeitung personenbezogener Daten
            </div>
            <span>
              Soweit die Cookies auf Basis einer Einwilligung gemäß Art. 6 Abs.
              1 lit. a DSGVO verarbeitet werden, gilt diese Einwilligung auch
              als Einwilligung im Sinne des § 25 Abs. 1 TDDDG für das Setzen des
              Cookies auf dem Endgerät des Nutzers. Soweit eine andere
              Rechtsgrundlage nach der DSGVO genannt wird (z.B. zur
              Vertragserfüllung oder zur Erfüllung gesetzlicher Pflichten),
              erfolgt die Speicherung bzw. das Setzen auf Basis einer Ausnahme
              gemäß § 25 Abs. 2 TDDDG. Diese liegt dann vor, „wenn der alleinige
              Zweck der Speicherung von Informationen in der Endeinrichtung des
              Endnutzers oder der alleinige Zweck des Zugriffs auf bereits in
              der Endeinrichtung des Endnutzers gespeicherte Informationen die
              Durchführung der Übertragung einer Nachricht über ein öffentliches
              Telekommunikationsnetz ist“ oder „wenn die Speicherung von
              Informationen in der Endeinrichtung des Endnutzers oder der
              Zugriff auf bereits in der Endeinrichtung des Endnutzers
              gespeicherte Informationen unbedingt erforderlich ist, damit der
              Anbieter eines digitalen Dienstes einen vom Nutzer ausdrücklich
              gewünschten digitalen Dienst zur Verfügung stellen kann“. Welche
              Rechtsgrundlage einschlägig ist, ergibt sich aus der später in
              diesem Punkt aufgeführten Cookie-Tabelle.
            </span>
          </li>
          <li>
            <div class="bold-font datenschutz-subsection">
              Zweck der Datenverarbeitung
            </div>
            <span>
              Die Cookies werden von unserer Website bzw. den externen
              Webservices gesetzt, um die volle Funktionalität unserer Website
              zu erhalten, die Benutzerfreundlichkeit zu verbessern oder um den
              mit Ihrer Einwilligung angegebenen Zweck zu verfolgen. Die
              Cookie-Technologie ermöglicht es uns auch, einzelne Besucher
              anhand von Pseudonymen, z.B. einer individuellen oder zufälligen
              IDs, zu erkennen, so dass wir mehr individuelle Dienstleistungen
              anbieten können. Details sind in der folgenden Tabelle aufgeführt.
            </span>
          </li>
          <li>
            <div class="bold-font datenschutz-subsection">
              Dauer der Speicherung
            </div>
            <span>
              Die Speicherung unserer Cookies erfolgt bis zur Löschung in Ihrem
              Browser oder, wenn es sich um einen Session-Cookie handelt, bis
              die Session abgelaufen ist. Details sind in der folgenden Tabelle
              aufgeführt.
            </span>
          </li>
          <li>
            <div class="bold-font datenschutz-subsection">
              Widerspruchs- und Beseitigungsmöglichkeit
            </div>
            <span>
              Sie können Ihren Browser nach Ihren Wünschen so einstellen, dass
              das Setzen von Cookies generell verhindert wird. Sie können dann
              von Fall zu Fall über die Annahme von Cookies entscheiden oder
              Cookies grundsätzlich akzeptieren. Cookies können für verschiedene
              Zwecke verwendet werden, z.B. um zu erkennen, dass Ihr
              Zugangsgerät bereits mit unserer Website verbunden ist (permanente
              Cookies) oder um zuletzt angesehene Angebote zu speichern
              (Session-Cookies). Wenn Sie uns ausdrücklich die Erlaubnis erteilt
              haben, Ihre personenbezogenen Daten zu verarbeiten können Sie
              diese Einwilligung jederzeit widerrufen. Bitte beachten Sie, dass
              die Rechtmäßigkeit der auf der Grundlage der Einwilligung bis zum
              Widerruf vorgenommenen Verarbeitung davon nicht berührt wird.
            </span>
            <br />
            <br />
            <table>
              <tr>
                <th class="bold-font">Cookie-Name</th>
                <th class="bold-font">Server</th>
                <th class="bold-font">Anbieter</th>
                <th class="bold-font">Zweck</th>
                <th class="bold-font">Rechtsgrundlage</th>
                <th class="bold-font">Speicherdauer</th>
                <th class="bold-font">Typ</th>
              </tr>
              <tr>
                <td class="bold-font">__cf_bm</td>
                <td></td>
                <td class="bold-font">Webseitenbetreiber</td>
                <td></td>
                <td class="bold-font">-----------</td>
                <td class="bold-font">-----------</td>
                <td class="bold-font">---</td>
              </tr>
              <tr>
                <td class="bold-font">_hjCookieTest</td>
                <td class="bold-font">content.deutsches-foerderportal.de</td>
                <td class="bold-font">Webseitenbetreiber</td>
                <td class="bold-font">
                  Das Cookie prüft, ob der Hotjar-Tracking-Code Cookies
                  verwenden kann.
                </td>
                <td class="bold-font">
                  Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO
                  (Einwilligung)
                </td>
                <td>Sitzung</td>
                <td class="bold-font">Konfiguration</td>
              </tr>
              <tr>
                <td class="bold-font">_hjSessionUser_</td>
                <td class="bold-font">.deutsches-foerderportal.de</td>
                <td class="bold-font">Webseitenbetreiber</td>
                <td class="bold-font">
                  Das Cookie vergibt eine Nutzer-ID. Es wird gesetzt, wenn ein
                  Nutzer zum ersten Mal eine Website mit Hotjar-Skript aufruft.
                  Dadurch wird sichergestellt, dass das Nutzungsverhalten auch
                  bei späteren Seitenbesuchen derselben Nutzer-ID zugeordnet
                  wird
                </td>
                <td class="bold-font">
                  Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO
                  (Einwilligung)
                </td>
                <td>ca. 12 Monate</td>
                <td>Analytics</td>
              </tr>
              <tr>
                <td class="bold-font">_hjSession_</td>
                <td class="bold-font">.deutsches-foerderportal.de</td>
                <td class="bold-font">Webseitenbetreiber</td>
                <td>
                  Das Cookie speichert die aktuellen Sitzungsdaten. Dadurch wird
                  sichergestellt, dass Anfragen im Sitzungszeitraum derselben
                  Hotjar-Sitzung zugeordnet werden-
                </td>
                <td class="bold-font">
                  Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO
                  (Einwilligung)
                </td>
                <td class="bold-font">ca. 30 Minuten</td>
                <td class="bold-font">Analytics</td>
              </tr>
              <tr>
                <td class="bold-font">_hjTLDTest</td>
                <td class="bold-font">.deutsches-foerderportal.de</td>
                <td class="bold-font">Hotjar</td>
                <td class="bold-font">
                  Wenn das Hotjar-Skript ausgeführt wird, versuchen wir, den
                  allgemeinsten Cookie-Pfad zu ermitteln, den wir anstelle des
                  Hostnamens der Seite verwenden sollten. Dies geschieht, damit
                  Cookies über Subdomains hinweg gemeinsam genutzt werden können
                  (falls zutreffend). Um dies zu ermitteln, versuchen wir, das
                  _hjTLDTest-Cookie für verschiedene URL-Substring-Alternativen
                  zu speichern, bis dies fehlschlägt. Nach dieser Prüfung wird
                  das Cookie entfernt.
                </td>
                <td class="bold-font">
                  Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO
                  (Einwilligung)
                </td>
                <td class="bold-font">Sitzung</td>
                <td class="bold-font">Analytics</td>
              </tr>
            </table>
          </li>
        </ul>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          2.4. Automatische E-Mail Archivierung
        </h4>
        <ul class="unordered-list">
          <li>
            <div class="bold-font">
              Umfang der Verarbeitung personenbezogener Daten
            </div>
            <span>
              Wir weisen Sie ausdrücklich darauf hin, dass unser Mailsystem über
              ein automatisiertes Archivierungsverfahren verfügt. Alle ein- und
              ausgehenden E-Mails werden hierdurch revisionssicher digital
              archiviert.
            </span>
          </li>
          <li>
            <div class="bold-font">
              Rechtsgrundlage für die Verarbeitung personenbezogener Daten
            </div>
            <span>
              Art. 6 Abs. 1 lit. c DSGVO (rechtliche Verpflichtung). Die
              rechtliche Verpflichtung besteht in der Einhaltung
              steuerrechtlicher und handelsrechtlicher Vorgaben (z.B. §§ 146,
              147 AO, §§ 238, 257 HGB).
            </span>
          </li>
          <li>
            <div class="bold-font">Zweck der Datenverarbeitung</div>
            <span>
              Der Zweck der Archivierung besteht in der Einhaltung
              steuerrechtlicher (z.B. §§ 146, 147 AO – Pflicht zur Aufbewahrung
              von E-Mails von steuerrechtlicher Relevanz) und handelsrechtlicher
              Vorgaben (z.B. §§ 238, 257 HGB – Pflicht zur Archivierung von
              Geschäftskorrespondenz).
            </span>
          </li>
          <li>
            <div class="bold-font">Dauer der Speicherung</div>
            <span>
              Die Speicherung unserer Mailkommunikation erfolgt bis zum Ablauf
              steuerrechtlicher und handelsrechtlicher Aufbewahrungspflichten.
              Die Aufbewahrungsdauer kann bis zu 10 Jahre betragen.
            </span>
          </li>
          <li>
            <div class="bold-font">Widerspruchs- und Löschungsmöglichkeit</div>
            <span>
              Sie können der Verarbeitung jederzeit gem. Art. 21 DSGVO
              widersprechen und eine Löschung von Daten gem. Art. 17 DSGVO
              verlangen. Welche Rechte Ihnen zustehen und wie Sie diese geltend
              machen, finden Sie im unteren Bereich dieser Datenschutzerklärung.
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="section">
      <h2 class="bold-font datenschutz-subheading">
        3. Abschnitt 3 - Ihre Rechte
      </h2>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          3.1. Auskunftsanspruch
        </h4>
        <span class="row datenschutz-subsection">
          Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob wir
          personenbezogene Daten von Ihnen verarbeiten. Sofern dies der Fall
          ist, haben Sie ein Recht auf Auskunft über die in Art. 15 Abs. 1, 2
          DSGVO benannten Informationen. Gerne stellen wir Ihnen auch eine Kopie
          der Daten zur Verfügung, soweit nicht die Rechte und Freiheiten
          anderer Personen beeinträchtigt werden (vgl. Art. 15 Abs. 4 DSGVO).
        </span>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          3.2. Berichtigungsanspruch
        </h4>
        <span class="row datenschutz-subsection">
          Sie haben gem. Art. 16 DSGVO das Recht, bei uns ggf. falsch
          hinterlegte personenbezogene Daten (wie z.B. Adresse, Name, etc.)
          jederzeit korrigieren zu lassen. Auch können Sie jederzeit eine
          Vervollständigung der bei uns gespeicherten Daten verlangen. Eine
          entsprechende Anpassung erfolgt unverzüglich.
        </span>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          3.3. Recht auf Löschung
        </h4>
        <span class="row datenschutz-subsection">
          Sie haben gem. Art. 17 Abs. Abs. 1 DSGVO das Recht darauf, dass wir
          die über Sie erhobenen personenbezogenen Daten löschen, wenn
        </span>
        <ul class="unordered-list">
          <li>die Daten nicht mehr benötigt werden;</li>
          <li>
            aufgrund des Widerrufs Ihrer Einwilligung die Rechtsgrundlage der
            Verarbeitung ersatzlos entfallen ist;
          </li>
          <li>
            Sie Widerspruch gegen die Verarbeitung eingelegt haben und keine
            vorrangigen berechtigte Gründe für die Verarbeitung vorliegen;
          </li>
          <li>Ihre Daten unrechtmäßig verarbeitet werden;</li>
          <li>eine rechtliche Verpflichtung dies erfordert</li>
          <li>eine Erhebung gem. Art. 8 Abs. 1 DSGVO stattgefunden hat.</li>
        </ul>
        <br />
        <span class="row datenschutz-subsection">
          Das Recht besteht gem. Art. 17 Abs. 3 DSGVO dann nicht, wenn
        </span>
        <ul class="unordered-list">
          <li>
            die Verarbeitung zur Ausübung des Rechtes auf freie Meinungsäußerung
            und Information erforderlich ist;
          </li>
          <li>
            Ihre Daten auf Grundlage einer rechtlichen Verpflichtung erhoben
            worden sind;
          </li>
          <li>
            die Verarbeitung aus Gründen des öffentlichen Interesses
            erforderlich ist;
          </li>
          <li>
            die Daten zur Geltendmachung, Ausübung oder Verteidigung von
            Rechtsansprüchen erforderlich sind.
          </li>
        </ul>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          3.4. Recht auf Einschränkung der Verarbeitung
        </h4>
        <span class="row datenschutz-subsection">
          Gem. Art. 18 Abs. 1 DSGVO haben Sie in einzelnen Fällen das Recht, die
          Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
          verlangen.
        </span>
        <br />
        <span class="row datenschutz-subsection">
          Dies ist dann der Fall, wenn
        </span>
        <ul class="unordered-list">
          <li>
            die Richtigkeit der personenbezogenen Daten von Ihnen bestritten
            wird;
          </li>
          <li>
            die Verarbeitung unrechtmäßig ist und Sie einer Löschung nicht
            zustimmen;
          </li>
          <li>
            die Daten nicht länger für den Verarbeitungszweck benötigt werden,
            aber die erhobenen Daten der Geltendmachung, Ausübung oder
            Verteidigung von Rechtsansprüchen dienen;
          </li>
          <li>
            ein Widerspruch gegen die Verarbeitung gem. Art. 21 Abs. 1 DSGVO
            eingelegt worden ist und noch unklar ist, welche Interessen
            überwiegen.
          </li>
        </ul>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          3.5. Recht auf Widerruf
        </h4>
        <span class="row datenschutz-subsection">
          Sofern Sie uns eine ausdrückliche Einwilligung in die Verarbeitung
          Ihrer personenbezogenen Daten erteilt haben (Art. 6 Abs. 1 lit. a
          DSGVO) können Sie diese jederzeit widerrufen. Bitte beachten Sie, dass
          die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf
          erfolgten Verarbeitung hierdurch nicht berührt wird.
        </span>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          3.6. Recht auf Widerspruch
        </h4>
        <span class="row datenschutz-subsection bold-font">
          Soweit Sie bei der Speicherung und Verarbeitung Ihrer Daten aufgrund
          einer besonderen Situation nicht mehr möchten, dass wir die Daten
          verarbeiten, können Sie bei Daten, die wir auf Basis von Art. 6 Abs. 1
          lit. f DSGVO (berechtigtes Interesse) erhoben haben, gemäß Art. 21
          DSGVO jederzeit Widerspruch einlegen.
        </span>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          3.7. Recht auf Datenübertragbarkeit
        </h4>
        <span class="row datenschutz-subsection">
          Wir stellen Ihnen oder einen von Ihnen benannten Verantwortlichen auf
          Anfrage gem. Art. 20 Abs. 1 DSGVO folgende Daten in einem gängigen
          maschinenlesbaren Format bereit:
        </span>
        <ul class="unordered-list">
          <li>
            Daten, die aufgrund einer ausdrücklichen Einwilligung gem. Art. 6
            Abs. 1 lit. a DSGVO oder Art. 9 Abs. 2 lit. a DSGVO erhoben wurden;
          </li>
          <li>
            Daten, die wir gemäß gem. Art. 6 Abs. 1 lit. b DSGVO im Rahmen
            bestehender Verträge von Ihnen erhalten haben; soweit die Daten im
            Rahmen eines automatisierten Verfahrens verarbeitet worden sind.
          </li>
        </ul>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          3.8. Wie nehmen Sie Ihre Rechte wahr?
        </h4>
        <span class="row datenschutz-subsection">
          Ihre Rechte können Sie jederzeit wahrnehmen, indem Sie sich an die
          unten stehenden Kontaktdaten wenden:
        </span>
        <br />
        <div class="datenschutz-subsection">
          Ignite GmbH Ernst-Heckel-Straße 6A
        </div>
        <div class="datenschutz-subsection">66386 St. Ingbert</div>
        <div class="datenschutz-subsection">Deutschland</div>
        <div class="datenschutz-subsection">
          E-Mail: &nbsp;<a href="mailto:info@ignite-group.de" target="_blank"
            >info@ignite-group.de</a
          >
        </div>
        <div class="datenschutz-subsection">Tel.: +49 6894 99956 – 0</div>
        <div class="datenschutz-subsection">Fax: +49 32 221739475</div>
      </div>
      <div class="section-content">
        <h4 class="bold-font datenschutz-subsubheading">
          3.9. Beschwerderecht bei der Aufsichtsbehörde gem. Art. 77 Abs. 1
          DSGVO
        </h4>
        <span class="row datenschutz-subsection">
          Sofern Sie den Verdacht haben, dass auf unserer Seite Ihre Daten
          rechtswidrig verarbeitet werden, können Sie selbstverständlich
          jederzeit eine gerichtliche Klärung der Problematik herbeiführen.
          Zudem steht Ihnen jede andere rechtliche Möglichkeit offen. Unabhängig
          davon steht Ihnen gem. Art. 77 Abs. 1 DSGVO die Möglichkeit zur
          Verfügung, sich an eine Aufsichtsbehörde zu wenden. Das
          Beschwerderecht gem. Art. 77 DSGVO steht Ihnen in dem EU-Mitgliedstaat
          Ihres Aufenthaltsortes, Ihres Arbeitsplatzes und/oder des Ortes des
          vermeintlichen Verstoßes zu, d.h. Sie können die Aufsichtsbehörde, an
          die Sie sich wenden, aus den oben genannten Orten wählen. Die
          Aufsichtsbehörde, bei der die Beschwerde eingereicht wurde,
          unterrichtet Sie dann über den Stand und die Ergebnisse Ihrer Eingabe,
          einschließlich der Möglichkeit eines gerichtlichen Rechtsbehelfs gem.
          Art. 78 DSGVO. Beispielsweise können Sie sich an die für uns
          zuständige Aufsichtsbehörde wenden:
        </span>
        <br />
        <div class="datenschutz-subsection">
          Unabhängiges Datenschutzzentrum Saarland
        </div>
        <div class="datenschutz-subsection">
          Fritz-Dobisch-Straße 12, 66111 Saarbrücken
        </div>
        <div class="datenschutz-subsection">
          E-Mail: &nbsp;
          <a href="mailto:poststelle@datenschutz.saarland.de" target="_blank">
            poststelle@datenschutz.saarland.de</a
          >
        </div>
        <br />
        <div class="datenschutz-subsection">Erstellt durch:</div>
        <div class="datenschutz-subsection">
          © DURY LEGAL Rechtsanwälte –
          <a href="http://www.dury.de/" target="_blank">www.dury.de</a>
        </div>
        <div class="datenschutz-subsection">
          © Website-Check GmbH –
          <a href="https://www.website-check.de/" target="_blank"
            >www.website-check.de</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DatenschutzPage",
  setup() {
    return {};
  },
};
</script>
